import { useTheme } from 'styled-components';

export const CustomStyles = enablePortal => {
  const theme = useTheme();

  return {
    menuPortal: base => ({ ...base, ...(enablePortal && { zIndex: theme.zIndex.select }) })
  };
};
